import { AnyAction } from 'redux';

import { ContentPlacement } from '@candu-ai/placement/types';
import { Snapshot } from '@candu-ai/snapshots/types';

import { SET_SNAPSHOT, SET_SNAPSHOT_LOADED } from './constants';

export interface SnapshotsState {
  snapshot?: Snapshot;
  placement?: ContentPlacement;
  isSnapshotLoaded: boolean;
}

export const initialState: SnapshotsState = {
  snapshot: undefined,
  placement: undefined,
  isSnapshotLoaded: false,
};

export const snapshotsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SNAPSHOT:
      return {
        ...state,
        snapshot: action.snapshot,
        placement: action.placement,
        isSnapshotLoaded:
          action.snapshot?.id !== undefined && state.snapshot?.id === action.snapshot.id
            ? state.isSnapshotLoaded
            : false,
      };
    case SET_SNAPSHOT_LOADED:
      return { ...state, isSnapshotLoaded: action.isLoaded };
    default:
      return state;
  }
};
